module.exports = __webpack_public_path__ + "img/comsmall.8b92baaa.png";